import {
    AddAssigneeNotification,
    RemoveAssigneeNotification,
    ActivityNoteCreationNotification,
    ActivityMeetCreationNotification,
} from '../../commonTypes/NotificationTypes/project.types';
import { TranslationFormatter } from './TranslationFormatter';
import { formatDateToDayMonthYearWithDashes } from '../date/dateFormater';

export class NotificationProjectService {
    private formatter: TranslationFormatter;

    constructor(formatter: TranslationFormatter) {
        this.formatter = formatter;
    }

    public generateAddAssigneeMessage(notification: AddAssigneeNotification): string {
        const { projectName, clientName } = notification.message;
        return this.formatter.getTranslation('notificationMessages.addAssignee', {
            projectName,
            clientName,
        });
    }

    public generateRemoveAssigneeMessage(notification: RemoveAssigneeNotification): string {
        const { projectName } = notification.message;
        return this.formatter.getTranslation('notificationMessages.removeAssignee', {
            projectName,
        });
    }

    public generateActivityNoteCreationMessage(notification: ActivityNoteCreationNotification): string {
        const { projectName, noteTitle } = notification.message;
        return this.formatter.getTranslation('notificationMessages.activityNoteCreation', {
            projectName,
            noteTitle,
        });
    }

    public generateActivityMeetCreationMessage(notification: ActivityMeetCreationNotification): string {
        const { projectName, meetTitle, meetDate } = notification.message;
        const formattedDate = formatDateToDayMonthYearWithDashes(meetDate);
        return this.formatter.getTranslation('notificationMessages.activityMeetCreation', {
            projectName,
            meetTitle,
            meetDate: formattedDate,
        });
    }
}
